module.exports = __webpack_public_path__ + "static/media/playlistadd.c8399d60.svg";